import React, {useState, useEffect} from 'react';
import {useTranslation} from "react-i18next";
import parse from "html-react-parser";
import {useFetching} from "../../../hooks/useFetching";
import {API_INDEX_ABOUT_US} from "../../../utils/consts";
import cookie from "js-cookie";
import ApiIndexAboutUs from "../../../services/Index/AboutUs";
import device from "current-device";

import pics from '../../../img/pics.png'
import pics_mobile from '../../../img/pics_mobile.png'
import {observer} from "mobx-react-lite";

const AboutUs = () => {
    const {t} = useTranslation();
    const curr_lang = cookie.get('i18next');
    const [text, setText] = useState('');
    // const [text, setText] = useState('<p>Здесь, в Champion, нам нравится создавать слоты, чтобы обеспечить каждому игроку лучший пользовательский опыт, как в современных, так и олдскульных играх. Мы предлагаем широкий выбор игр, которые удовлетворят даже самого придирчивого клиента. На сегодняшний день мы разработали 62 игры: 52 слота и 10 настольных игр.</p> <p>Наши игры уже приносят радость в СНГ, Европе и Канаде.</p> <p>Мы более чем рады предложить:</p> <ul> <li>Потрясающие игры с самым лучшим пользовательским интерфейсом, которые принесут большую прибыль</li> <li>Адаптивы для мобильных устройств, планшетов и ПК</li> <li>Простота в интеграции API</li> <li>Техническая поддержка, которая доступна 24/7</li> <li>Сертифицированный и протестированный ГСЧ (подходит практически для каждого рынка)</li> <li>Данные и аналитика в реальном времени</li> <li>Доступно 19 языков</li> <li>Поддержка большинства мировых валют</li> <li>Удобный бэк-офис</li> </ul> <p>Позвольте вашим игрокам почувствовать игру! Свяжитесь с нами сейчас для БЕСПЛАТНОЙ интеграции!</p>');

    const [FunctionApiIndexAboutUs] = useFetching(async () => {
        const response = await ApiIndexAboutUs.getApiIndexAboutUs(API_INDEX_ABOUT_US);
        setText(response.data.text);
    });

    useEffect(() => {
        FunctionApiIndexAboutUs();
    }, [curr_lang]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            {text && <div className="aboutUs">
                <div className="block_center">
                    <div className="block_left">
                        <img src={device.mobile() ? pics_mobile : pics} alt={t('About Us')} />
                    </div>
                    <div className="block_right">
                        <h2>{t('About Us')}</h2>
                        {text && parse(text)}
                    </div>
                </div>
            </div>}
        </>
    );
};

export default observer(AboutUs);